import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaUser, FaKey, FaMale, FaFemale } from 'react-icons/fa';
// import Top from '../dashboard/Top/top';
import Footer from '../../components/Footer/Footer';
import Notification from '../../components/notification';
import Credits from '../../components/Credits/Credits';
import './profile.css';
import { changePassword, updateProfile, getProfile } from '../../api/api';

const Profile = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(() => {
    const savedProfile = localStorage.getItem('userProfile');
    return savedProfile ? JSON.parse(savedProfile) : {
      username: '',
      email: '',
      bio: '',
      gender: '',
      credits: 0
    };
  });

  // Update localStorage whenever profile changes
  useEffect(() => {
    localStorage.setItem('userProfile', JSON.stringify(profile));
  }, [profile]);

  const [isEditing, setIsEditing] = useState(false);
  const [notification, setNotification] = useState(null);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setNotification({ type: 'error', message: 'Please sign in to view your profile.' });
          navigate('/sign-in');
          return;
        }

        const response = await getProfile();
        console.log(response);
        if (response.status === 200) {
          const profileData = response.data;
          setProfile(profileData);
          localStorage.setItem('userProfile', JSON.stringify(profileData));
          localStorage.setItem('userCredits', profileData.credits.toString());
          localStorage.setItem('userId', profileData.userId);
        }
      } catch (error) {
        console.log(error);
        if (error.response?.status === 401) {
          setNotification({ type: 'error', message: 'Session expired. Please sign in again.' });
          localStorage.removeItem('userProfile');
          localStorage.removeItem('userCredits');
          navigate('/sign-in');
        } else if (error.response?.status === 404) {
          setNotification({ type: 'error', message: 'Profile not found.' });
        } else {
          setNotification({ 
            type: 'error', 
            message: 'Failed to fetch profile data.' 
          });
        }
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGenderSelect = (gender) => {
    setProfile(prev => ({
      ...prev,
      gender
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setNotification({ type: 'error', message: 'Please sign in again.' });
        return;
      }

      const response = await updateProfile({
        bio: profile.bio,
        gender: profile.gender
      });

      if (response.status === 200) {
        setNotification({ type: 'success', message: 'Profile updated successfully!' });
        setIsEditing(false);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setNotification({ type: 'error', message: 'User not found.' });
      } else if (error.response?.status === 500) {
        setNotification({ type: 'error', message: 'Server error. Please try again later.' });
      } else {
        setNotification({ type: 'error', message: 'Failed to update profile. Please try again.' });
      }
    }
  };






  
  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setNotification({ type: 'error', message: 'Passwords do not match!' });
      return;
    }
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setNotification({ type: 'error', message: 'Please sign in again.' });
        navigate('/sign-in');
      }

      // Configure axios with the token
      const response = await changePassword({
        oldPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword
      });

      if (response.status === 200) {
        setNotification({ type: 'success', message: 'Password updated successfully!' });
        setIsChangingPassword(false);
        setPasswordForm({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
      }
    } catch (error) {
      if (error.response.status === 401) {
        setNotification({ type: 'error', message: 'Old password is incorrect.' });
      } else if (error.response.status === 404) {
        setNotification({ type: 'error', message: 'User not found.' });
      } else if (error.response.status === 500) {
        setNotification({ type: 'error', message: 'Server error. Please try again later.' });
      }else{
        setNotification({ type: 'error', message: 'Failed to update password. Please try again.' });
      }
    }
  };

  return (
    <div className="profile-container">
      {/* <Top /> */}
      <main className="profile-main">
        <div className="profile-header">
          <div className="profile-avatar">
            {profile.gender === 'male' ? <FaMale /> : profile.gender === 'female' ? <FaFemale /> : <FaUser />}
          </div>
          <h2 className="profile-name">{profile.username}</h2>
          <p className="profile-email">{profile.email}</p>
        </div>

        <div className="profile-grid">
          <div className="profile-section">
            <h3 className="section-title">Profile Information</h3>
            <form onSubmit={handleUpdateProfile}>
              <div className="form-group">
                <label className="form-label">Bio</label>
                <textarea
                  name="bio"
                  value={profile.bio}
                  onChange={handleProfileChange}
                  className="form-input form-textarea"
                  placeholder="Tell us about yourself..."
                />
              </div>

              <div className="form-group">
                <label className="form-label">Gender</label>
                <div className="gender-options">
                  <button
                    type="button"
                    className={`gender-option ${profile.gender === 'male' ? 'selected' : ''}`}
                    onClick={() => handleGenderSelect('male')}
                  >
                    Male
                  </button>
                  <button
                    type="button"
                    className={`gender-option ${profile.gender === 'female' ? 'selected' : ''}`}
                    onClick={() => handleGenderSelect('female')}
                  >
                    Female
                  </button>
                </div>
              </div>

              <button type="submit" className="profile-button">
                Update Profile
              </button>
            </form>
          </div>

          <div className="profile-section">
            <Credits />

            {!isChangingPassword ? (
              <button
                className="profile-button"
                onClick={() => setIsChangingPassword(true)}
              >
                <FaKey style={{ marginRight: '0.5rem' }} />
                Change Password
              </button>
            ) : (
              <form onSubmit={handleUpdatePassword}>
                <h3 className="section-title">Change Password</h3>
                <div className="form-group">
                  <label className="form-label">Current Password</label>
                  <input
                    type="password"
                    name="currentPassword"
                    value={passwordForm.currentPassword}
                    onChange={handlePasswordChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input
                    type="password"
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={handlePasswordChange}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Confirm New Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={passwordForm.confirmPassword}
                    onChange={handlePasswordChange}
                    className="form-input"
                    required
                  />
                </div>

                <button type="submit" className="profile-button">
                  Update Password
                </button>
                <button
                  type="button"
                  className="profile-button danger"
                  onClick={() => setIsChangingPassword(false)}
                >
                  Cancel
                </button>
              </form>
            )}
          </div>

          <div className="profile-section payment-history">
            <h3 className="section-title">Payment History</h3>
            {profile.paymentHistory && profile.paymentHistory.length > 0 ? (
              <div className="payment-history-list">
                {profile.paymentHistory.map((payment, index) => (
                  <div key={index} className={`payment-history-item ${payment.status}`}>
                    <div className="payment-header">
                      <span className={`payment-status ${payment.status}`}>
                        {payment.status.charAt(0).toUpperCase() + payment.status.slice(1)}
                      </span>
                      <span className="payment-date">
                        {new Date(payment.paymentDate).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="payment-details">
                      <div className="payment-package">
                        <strong>{payment.package.name}</strong>
                        <span className="payment-duration">({payment.package.duration})</span>
                      </div>
                      <div className="payment-amount">
                        {payment.package.currency} {payment.package.amount}
                      </div>
                    </div>
                    {payment.errorMessage && (
                      <div className="payment-error">
                        {payment.errorMessage}
                      </div>
                    )}
                    <div className="payment-method">
                      Via {payment.paymentMethod}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-payments">
                No payment history available
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default Profile; 